import * as XLSX from 'xlsx';

const getColumns = (coupons = []) => {
  const hasSimple = coupons.some((c) => Number(c.simple || 0) > 0);
  const hasDouble = coupons.some((c) => Number(c.double || 0) > 0);
  const hasAdequaSimple = coupons.some((c) => Number(c.adequa_simple || 0) > 0);
  const hasAdequaDouble = coupons.some((c) => Number(c.adequa_double || 0) > 0);

  return [
    { key: 'year', label: 'Año' },
    { key: 'month', label: 'Mes' },
    { key: 'fee_number1', label: 'Cuota 1' },
    { key: 'fee_number2', label: 'Cuota 2' },
    hasSimple && { key: 'simple', label: 'Diferimiento simple' },
    hasDouble && { key: 'double', label: 'Diferimiento doble' },
    hasAdequaSimple && { key: 'adequa_simple', label: 'Diferimiento de adecuación simple' },
    hasAdequaDouble && { key: 'adequa_double', label: 'Diferimiento de adecuación doble' },
    { key: 'total', label: 'Total diferido' },
  ].filter(Boolean);
};

const formatNumber = (value) => Number(value || 0).toFixed(2);

const getCalcReferences = (coupons = []) => {
  const hasSimple = coupons.some((c) => Number(c.simple || 0) > 0);
  const hasDouble = coupons.some((c) => Number(c.double || 0) > 0);
  const hasAdequaSimple = coupons.some((c) => Number(c.adequa_simple || 0) > 0);
  const hasAdequaDouble = coupons.some((c) => Number(c.adequa_double || 0) > 0);

  const refs = [];
  if (hasAdequaSimple) refs.push('Diferimiento de adecuación simple: porcentaje / 100 * 2/3 cuotas.');
  if (hasAdequaDouble) refs.push('Diferimiento de adecuación doble: porcentaje / 100 * 4/3 cuotas.');
  if (hasSimple) refs.push('Diferimiento simple: porcentaje / 100 cuotas.');
  if (hasDouble) refs.push('Diferimiento doble: porcentaje / 100 * 2 cuotas.');
  return refs;
};

export const exportDifferimentDetailToExcel = (detail) => {
  if (!detail) return;

  const coupons = detail.coupons || [];
  const columns = getColumns(coupons);

  const sheetCoupons = coupons.map((c) => {
    const row = {};
    columns.forEach((col) => {
      if (col.key === 'fee_number1') {
        row[col.label] = c.fee_number1 === 0 ? 'Adecuación' : c.fee_number1 ?? '-';
      } else if (col.key === 'fee_number2') {
        row[col.label] = c.fee_number2 ?? '-';
      } else if (col.key === 'year' || col.key === 'month') {
        row[col.label] = c[col.key] ?? '-';
      } else {
        row[col.label] = formatNumber(c[col.key]);
      }
    });
    return row;
  });

  const sheetTotals = [
    {
      concepto: 'Diferimiento histórico',
      cuotas: formatNumber(detail.total_differiment),
    },
    {
      concepto: 'Diferimiento pagado',
      cuotas: formatNumber(detail.paid_differiment),
    },
    {
      concepto: 'Diferimiento pendiente',
      cuotas: formatNumber(detail.pending_differiment),
    },
  ];

  const workbook = XLSX.utils.book_new();
  const wsCoupons = XLSX.utils.json_to_sheet(sheetCoupons);
  XLSX.utils.book_append_sheet(workbook, wsCoupons, 'Cupones');
  const wsTotals = XLSX.utils.json_to_sheet(sheetTotals);
  XLSX.utils.book_append_sheet(workbook, wsTotals, 'Totales');

  XLSX.writeFile(workbook, `Diferimiento_${detail.contract_number || 'detalle'}.xlsx`);
};

export const exportDifferimentDetailToPdf = (detail) => {
  if (!detail) return;
  const popup = window.open('', '_blank', 'width=900,height=700');
  if (!popup) return;

  const coupons = detail.coupons || [];
  const columns = getColumns(coupons);
  const references = getCalcReferences(coupons);

  const couponsRows = coupons
    .map(
      (c) =>
        `<tr>
          ${columns
            .map((col) => {
              if (col.key === 'fee_number1') {
                return `<td>${c.fee_number1 === 0 ? 'Adecuación' : c.fee_number1 ?? '-'}</td>`;
              }
              if (col.key === 'fee_number2') {
                return `<td>${c.fee_number2 ?? '-'}</td>`;
              }
              if (col.key === 'year' || col.key === 'month') {
                return `<td>${c[col.key] ?? '-'}</td>`;
              }
              return `<td>${formatNumber(c[col.key])} cuotas</td>`;
            })
            .join('')}
        </tr>`
    )
    .join('');

  popup.document.write(`
    <html>
      <head>
        <title>Diferimiento ${detail.contract_number}</title>
        <style>
          table { width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; }
          th, td { border: 1px solid #ccc; padding: 6px; text-align: left; font-size: 12px; }
          h2 { margin: 8px 0; }
          ul { margin: 6px 0 0 16px; padding: 0; }
          li { margin-bottom: 2px; }
        </style>
      </head>
      <body>
        <h2>Contrato: ${detail.contract_number}</h2>
        <table>
          <thead>
            <tr>
              ${columns.map((c) => `<th>${c.label}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${
              couponsRows ||
              `<tr><td colspan="${columns.length}" style="text-align:center;">Sin cupones</td></tr>`
            }
          </tbody>
        </table>
        <h3>Diferimiento total = histórico - pagado</h3>
        <p><strong>Histórico:</strong> ${formatNumber(detail.total_differiment)} cuotas</p>
        <p><strong>Pagado:</strong> ${formatNumber(detail.paid_differiment)} cuotas</p>
        <p><strong>Pendiente:</strong> ${formatNumber(detail.pending_differiment)} cuotas</p>
        ${
          references.length
            ? `<h4>Referencias de cálculo</h4>
               <ul>
                 ${references.map((r) => `<li>${r}</li>`).join('')}
               </ul>`
            : ''
        }
      </body>
    </html>
  `);
  popup.document.close();
  popup.print();
};
